import { Icon } from '@iconify/react';
import windowsFilled from '@iconify/icons-ant-design/windows-filled';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography, Stack } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.warning.darker,
  backgroundColor: theme.palette.warning.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.warning.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.warning.dark, 0)} 0%, ${alpha(
    theme.palette.warning.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const YUDING = 56;
const TOTAL = 89;

export default function AppItemOrders() {
  return (
    <RootStyle>
      <IconWrapperStyle>
        {/* <Icon icon={windowsFilled} width={24} height={24} /> */}
        <Icon icon="fa-solid:parking" width={24} height={24} />
      </IconWrapperStyle>
      <Stack direction='row' justifyContent={'space-evenly'}>
        <Stack>
          <Typography variant="h3">{fShortenNumber(YUDING)}</Typography>
          <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
            可预订车位（当前）
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="h3">{fShortenNumber(TOTAL)}</Typography>
          <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
            总共车位（当前）
          </Typography>
        </Stack>
      </Stack>
    </RootStyle>
  );
}
